/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { ColumnApi } from '@ag-grid-community/core';

export const getLastDataColumn = (columnApi: ColumnApi) => {
  const columns = columnApi.getColumns();
  const last = columns?.[columns.length - 1];
  if (!columns || !columns.length || !last) return null;
  const index = last.getColId() === 'context-menu' ? columns.length - 2 : columns.length - 1;
  return columns[index];
};
